import { render, staticRenderFns } from "./_createPassword.vue?vue&type=template&id=78fd3f27"
import script from "./_createPassword.vue?vue&type=script&lang=js"
export * from "./_createPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports